import { FunctionComponent, useEffect } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { useTranslation } from 'react-i18next'
import { TablePagination } from 'components/TablePagination'
import { useQueryState } from 'react-router-use-location-state'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { NewsTable } from './news-table'
import { toast } from 'react-toastify'
import { useDeleteNewsMutation, useNewsQuery } from 'services/info-center/news'
import { useNavigate } from 'react-router-dom'

export const News: FunctionComponent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
  } as const

  const { data: news, isError, isLoading } = useNewsQuery(args)
  const [
    deleteNews,
    { isSuccess: isDeleteNewsSuccess, isError: isDeleteNewsError },
  ] = useDeleteNewsMutation()

  const handleDeleteNews = (id: string) => {
    deleteNews({ id })
  }

  useEffect(() => {
    if (isDeleteNewsSuccess) {
      toast.success(t('operation-success'))
    }

    if (isDeleteNewsError) {
      toast.success(t('operation-failure'))
    }
  }, [isDeleteNewsSuccess, isDeleteNewsError, t])

  if (isLoading) return <Loading />

  if (isError) return <Error />

  if (news === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      <Box display="flex" justifyContent="space-between">
        <Typography fontWeight="bold" variant="h6">
          {t('news')}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={() => navigate('/portal/news/create')}
        >
          {t('create')}
        </Button>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {news && news.items.length > 0 && (
        <NewsTable news={news.items} onDelete={handleDeleteNews} />
      )}

      {news.info.totalRows !== 0 && (
        <TablePagination
          total={news.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PageWrapper>
  )
}
